import * as React from 'react';
import { IUSLog } from '../../model/Unserviceable/IUSLog';
import { calculateUSLogs } from '../../utils/commonMethods';

interface ITotalUnserviceableHoursColumnProps {
  displayText: string;
  logs: IUSLog[];
}

const TotalUnserviceableHoursColumn: React.FunctionComponent<ITotalUnserviceableHoursColumnProps> = ({ displayText, logs, ...props }) => {
  return (
    <>
      <td colSpan={1} className='text-right'>
        {displayText}
      </td>
      <td colSpan={2} className='fontBold'>
        {calculateUSLogs(logs, 1)}
      </td>
    </>
  );
};

export default TotalUnserviceableHoursColumn;
